var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGround(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 46.62,
    cy: 191.5,
    r: 5.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 58.2,
    cy: 200.44,
    rx: 5.63,
    ry: 8.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 75.69,
    cy: 241.74,
    rx: 6.21,
    ry: 4.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 32.55,
    cy: 211.1,
    rx: 8.12,
    ry: 10.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.84,228.54c-3.11,0-5.64,1.01-5.64,2.26c0,1.25,2.52,2.26,5.64,2.26c3.11,0,5.64-1.01,5.64-2.26 C69.48,229.55,66.95,228.54,63.84,228.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.5,176.33c0.73-0.12,1.47-0.24,2.22-0.37c1.29,2.5,4.85,4.3,9.06,4.3c1.1,0,2.15-0.13,3.13-0.35 c0.84,2.77,3.4,4.79,6.45,4.79c3.72,0,6.73-3.02,6.73-6.73c0-3.38-2.5-6.17-5.74-6.65c0.72-0.23,1.43-0.46,2.13-0.69 c2.81,1.74,7.26,2.87,12.29,2.87c8.51,0,15.41-3.22,15.41-7.2c0-0.64-0.2-1.27-0.54-1.86c0.34-1.01,0.54-2.09,0.54-3.22 c0-5.53-4.49-10.02-10.02-10.02c-1.72,0-3.34,0.43-4.75,1.2C254.66,125.03,166.14,22,151.18,22 C128.02,22,27.51,144.55,26.94,149.63c0,0-1.89,6.81-2.39,13.21c-0.89-0.23-1.83-0.37-2.79-0.37c-6.08,0-11.01,4.93-11.01,11.01 s4.93,11.01,11.01,11.01c5.41,0,9.9-3.9,10.83-9.05c2.52,0.56,5.44,0.84,8.74,0.95c-0.41,0.77-0.65,1.65-0.65,2.59 c0,3.04,2.47,5.51,5.51,5.51c0.83,0,1.62-0.19,2.32-0.52c1.41,1.63,3.5,2.67,5.83,2.67c3.08,0,5.74-1.82,6.97-4.43 c0.35,0.38,0.81,0.72,1.34,1.02c-1.38,1.05-2.21,2.33-2.21,3.71c0,3.54,5.31,6.41,11.87,6.41c1.17,0,2.3-0.1,3.37-0.27 c0.91,1.65,2.9,2.99,5.46,3.73c-3.5,1.25-6.02,4.59-6.02,8.52c0,5,4.05,9.05,9.05,9.05c3.75,0,6.96-2.28,8.33-5.52 c0.64,0.32,1.36,0.51,2.12,0.51c2.66,0,4.82-2.16,4.82-4.82s-2.16-4.82-4.82-4.82c-1.02,0-1.97,0.32-2.75,0.87 c-0.88-1.43-2.15-2.6-3.66-3.36c4.58-0.69,7.99-3.19,7.99-6.18c0-1.83-1.28-3.47-3.31-4.63c0.17-0.59,0.26-1.22,0.26-1.87 c0-0.38-0.04-0.76-0.1-1.12c1.85,0.38,3.89,0.77,6.18,1.2c1.32,0.24,2.47,0.43,3.5,0.57c-2.01,2.53-3.28,6.23-3.28,10.37 c0,7.62,4.29,13.8,9.58,13.8s9.58-6.18,9.58-13.8c0-1.94-0.28-3.79-0.78-5.46c0.87,0.85,2.06,1.38,3.38,1.38 c0.31,0,0.61-0.04,0.9-0.09c1.4,4.87,4.87,8.33,8.93,8.33c1.59,0,3.09-0.54,4.41-1.47c-0.38,0.55-0.6,1.17-0.6,1.81 c0,2.48,3.13,4.49,6.99,4.49c3.86,0,6.99-2.01,6.99-4.49c0-2.48-3.13-4.49-6.99-4.49c-1.83,0-3.49,0.45-4.73,1.19 c2.14-2.4,3.51-6.03,3.53-10.11c1.43,0.67,3.18,1.16,5.11,1.41c0.29,2.96,3.06,5.28,6.45,5.28c1.11,0,2.16-0.25,3.08-0.69 c1.04,0.45,2.19,0.69,3.4,0.69c4.79,0,8.67-3.88,8.67-8.67c0-0.46-0.05-0.91-0.12-1.35c1.94,0.71,4.55,1.15,7.43,1.15 c0.23,0,0.45-0.01,0.67-0.01c-0.88,1.13-1.38,2.42-1.38,3.8c0,4.43,5.18,8.02,11.58,8.02c6.39,0,11.58-3.59,11.58-8.02 c0-0.72-0.15-1.41-0.4-2.07c0.77,0.26,1.59,0.41,2.45,0.41c3.93,0,7.17-2.95,7.63-6.76c1.27,0.26,2.68,0.41,4.18,0.41 c1.55,0,3.02-0.16,4.32-0.45c-0.43,1.95-0.67,4.05-0.67,6.24c0,10.22,5.06,18.51,11.29,18.51s11.29-8.29,11.29-18.51 C237.19,182.48,236.57,179.16,235.5,176.33z M61.47,176.03c1.72,0.03,2.74,0.15,3.53,0.35c-1.22,0.3-2.27,0.77-3.06,1.36 C61.85,177.14,61.7,176.57,61.47,176.03z M76.9,181.04c-0.42-0.09-0.85-0.17-1.28-0.24c0.04-0.18,0.07-0.36,0.07-0.54 c0-0.29-0.05-0.58-0.15-0.85C75.85,180.06,76.31,180.62,76.9,181.04z M79.32,181.78c0.2,0,0.38-0.03,0.57-0.06 c-0.04,0.08-0.07,0.16-0.11,0.25C79.64,181.91,79.48,181.85,79.32,181.78z M191.57,177.64c-0.07,0.41-0.11,0.84-0.11,1.27 c0,0.95,0.18,1.85,0.49,2.69c-1.67-0.77-3.65-1.24-5.78-1.33c0.77-0.66,1.68-1.45,3.98-2.21 C190.61,177.91,191.09,177.77,191.57,177.64z M116.35,186.64c0,0.02,0.01,0.04,0.01,0.06c-0.81-1.39-1.81-2.53-2.93-3.37 c1.17-0.59,2.77-1.14,5.57-1.43c1.01-0.1,2.08-0.24,3.19-0.38c-0.04,0.12-0.06,0.24-0.09,0.35c-0.29-0.05-0.58-0.09-0.88-0.09 C118.52,181.79,116.35,183.96,116.35,186.64z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 125.38,
    cy: 235.14,
    rx: 9.04,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.68,228.54c2.65,0,4.8-1.52,4.8-3.39c0-1.87-2.15-3.39-4.8-3.39s-4.8,1.52-4.8,3.39 C155.88,227.02,158.03,228.54,160.68,228.54z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 148.82,
    cy: 210.62,
    rx: 8.19,
    ry: 6.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -93.5202 198.8582)",
    className: "st0",
    cx: 193.28,
    cy: 212.32,
    rx: 7.76,
    ry: 7.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.85,202.89c0-1.35-1.1-2.45-2.45-2.45c-1.35,0-2.45,1.1-2.45,2.45s1.1,2.45,2.45,2.45 C177.75,205.34,178.85,204.24,178.85,202.89z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 239.43,
    cy: 215.57,
    r: 6.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -66.0729 245.4525)",
    className: "st0",
    cx: 263.25,
    cy: 202.48,
    rx: 6.9,
    ry: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 249.07,
    cy: 199.03,
    r: 3.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.0584 254.1034)",
    className: "st0",
    cx: 281.2,
    cy: 188.68,
    rx: 11.05,
    ry: 11.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -35.7411 36.0298)",
    className: "st0",
    cx: 205.61,
    cy: 239.7,
    rx: 4.56,
    ry: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.4,237.43c-2.14,0-3.88,4.71-3.88,10.52s1.74,10.52,3.88,10.52c2.14,0,3.88-4.71,3.88-10.52 S191.55,237.43,189.4,237.43z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 163.78,
    cy: 248.12,
    rx: 10.16,
    ry: 6.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.84,254.51c-2.11,0-3.81,1.71-3.81,3.81c0,2.11,1.71,3.81,3.81,3.81c2.11,0,3.81-1.71,3.81-3.81 C138.65,256.22,136.95,254.51,134.84,254.51z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 96.2,
    cy: 244,
    rx: 9.98,
    ry: 6.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100.15,
    cy: 229.1,
    r: 3.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 125.38,
    cy: 217.04,
    rx: 9.04,
    ry: 4.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150.79,
    cy: 238.14,
    r: 5.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.31,212.32c-2.14,0-3.88,1.74-3.88,3.88c0,2.14,1.74,3.88,3.88,3.88s3.88-1.74,3.88-3.88 C177.19,214.05,175.45,212.32,173.31,212.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.72,230.8c-1.83,0-3.32,1.49-3.32,3.32s1.49,3.32,3.32,3.32s3.32-1.49,3.32-3.32 S181.55,230.8,179.72,230.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 215.52,
    cy: 214.73,
    r: 5.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 77.85,
    cy: 220.91,
    rx: 8.37,
    ry: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51.1,
    cy: 220.67,
    r: 4.48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGround);
export default __webpack_public_path__ + "static/media/ground.e28f3314df44d25c3fc197902ad22427.svg";
export { ForwardRef as ReactComponent };